import React, { SVGProps } from "react";

function PhoneIconComponent({
    title = null,
    color = "currentColor",
    size = "20",
    className = null,
}) {
    const props: SVGProps<SVGSVGElement> = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        role: title ? "img" : "presentation",
        viewBox: "0 0 20 20",
    };
    if (className) props.className = className;

    return (
        <svg {...props}>
            <title>{title}</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 .4h20v20H0z" />
                <path
                    d="M13.333.833H6.667a2.497 2.497 0 0 0-2.5 2.5v13.334c0 1.383 1.116 2.5 2.5 2.5h6.666c1.384 0 2.5-1.117 2.5-2.5V3.333c0-1.383-1.116-2.5-2.5-2.5zM10.75 17.75h-1.5v-1.5h1.5v1.5zM14.375 15h-8.75V3.333h8.75V15z"
                    fill={color}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
}

export default PhoneIconComponent;
